export { default as metamask } from "./metamask.svg";
export { default as walletConnect } from "./wallet-connect.svg";
export { default as coinbase } from "./coinbase.svg";
export { default as wallet } from "./wallet.svg";
